﻿export class Command {
    constructor(name, action) {
        this._name = name;
        this._action = action;
    }

    Invoke(params) {
        this._params = params
        this._action(this._params);
    }
}